module.exports = "https://store.zigzag.kr/resources/arm64/20260219-1022-e317b67041_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";